import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { Rating, RatingChangeEvent } from '@progress/kendo-react-inputs';
import { useContext, useState } from 'react';



export function ConfirmDialog ({
    type,
    title,
    message,
    confirmButtonText,
    cancelButtonText,
    onConfirm,
    onClose
}){
    var dlgClass ="" 
    switch (type){
            case "INFO":
                dlgClass="dlg-info"
                break;
            case "WARN":
                dlgClass="dlg-warn"
                break;
            case "DANGER":
                dlgClass="dlg-error"
                break;
            default:
                dlgClass="dlg-info"
                break;
    }
    return(
        <Dialog title={title} onClose={onClose} width={"25%"} className={dlgClass}>
            <p><span dangerouslySetInnerHTML={{__html:message}}/></p>
            <DialogActionsBar>
                <Button onClick={onConfirm} themeColor={"secondary"}>{confirmButtonText}</Button>
                <Button onClick={onClose} themeColor={"primary"}>{cancelButtonText}</Button>
            </DialogActionsBar>
        </Dialog>
    )
}

export function AlertDialog ({
    type,
    title,
    message,
    confirmButtonText,
    onClose
}){
    var dlgClass ="" 
    switch (type){
        case "INFO":
            dlgClass="atol-dlg-info"
            break;
        case "WARN":
            dlgClass="atol-dlg-warn"
            break;
        case "DANGER":
            dlgClass="atol-dlg-error"
            break;
        default:
            dlgClass="atol-dlg-info"
            break;
    }
    return(

        <Dialog className='atol-dlg-error' title={title} onClose={onClose}>
            <p>{message}</p>
            <DialogActionsBar>
                <Button onClick={onClose}>{confirmButtonText}</Button>
            </DialogActionsBar>
        </Dialog>
    )
}
